<template>
  <div class="orders">
    <loading-panel :loading="loading">
      <div class="text-center mb-3">
        <router-link to="/orders">Back to Orders</router-link>
      </div>
      <h2 class="text-center">Order Details</h2>
      <div v-if="order" class="m-auto">
        <table class="table table-striped table-thick m-auto w-100">
          <thead>
            <tr>
              <th>Date Placed</th>
              <th>Confirmation #</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ new Date(order.createdAt).toLocaleString() }}</td>
              <td>{{ $consts.ORDER_NUM_BASE + order.id }}</td>
              <td>${{ order.price.toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
        <hr />

        <table class="table table-striped table-thick m-auto w-100">
          <thead>
            <tr>
              <th>Line Item</th>
              <th>Quantity</th>
              <th>Price per Unit ($)</th>
              <th>Total Price ($)</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(option, i) in order.checkout_option_responses"
              :key="`line-item-${i}`"
              :set="applicableCount = getApplicableNodeCount(option)"
            >
              <!-- Item name -->
              <td>{{option.checkout_option.label}}</td>
              <!-- Item count -->
              <td v-if="!option.nodeTypesJsonSnapshot">
                <!-- if the option is not per-node in nature, it's count is 1 -->
                x1
              </td>
              <td v-else>x{{applicableCount}}</td>

              <td>{{option.priceSnapshot.toFixed(2)}}</td>

              <td>{{(option.priceSnapshot * (applicableCount)).toFixed(2)}}</td>
            </tr>
          </tbody>
        </table>

        <hr />
        <h4>Nodes</h4>
        <table class="table table-striped m-auto w-100">
          <thead>
            <tr>
              <th>Title</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(node, i) in nodes" :key="`types-${i}`">
              <td>{{ node.title }}</td>
              <td>{{ $consts.NODE_LABELS_FOR_INT_TYPE[node.node.type] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <error-panel class="m-auto" :errors="errors"></error-panel>
    </loading-panel>
  </div>
</template>

<script>
export default {
  name: "companies",
  components: {},
  data: () => ({
    loading: false,
    order: null,
    nodes: [],
    errors: []
  }),
  methods: {
    getNodesForType(typeString) {
      return this.nodes.filter(
        node => node.node.type == this.$consts.NODE_TYPE_STR_TO_INT[typeString]
      );
    },
    getApplicableNodeCount(option) {
      let applicableNodeTypes = JSON.parse(option.nodeTypesJsonSnapshot);
      if (!applicableNodeTypes) {
        return 1;
      }

      let total = 0;
      applicableNodeTypes.forEach(type => {
        total += this.nodes.filter(node => node.node.type == type).length;
      });

      return total;
    }
  },
  computed: {
    orderId() {
      return this.$route.params.orderId;
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getOrderForUser(this.orderId);
      this.order = response.data.order;
      this.nodes = response.data.nodes;

      // Sort nodes by OUTER_SORT: node type, INNER_SORT: title
      this.nodes.sort(
        (a, b) => a.title[0].toLowerCase() > b.title[0].toLowerCase()
      );
      this.nodes.sort((a, b) => a.node.type - b.node.type);
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.orders {
  padding: 20px;
  max-width: 768px;
  margin: auto;
}

h3 {
  text-align: center;
}
</style>
